import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const citizenship = dictionary.extend({
  name: z.string().min(1),
  sort_order: z.coerce.number().min(0),
});

export const readCitizenship = citizenship.readonly();
export const writeCitizenship = citizenship.omit({ id: true });
